export default {
  promotedFilterEnable: state => state.promotedFilterEnable,
  promotedByDateRangeMode: state => state.promotedByDateRangeMode,
  promoteDateObject: state => state.promoteDateObject,
};
